module.exports = __webpack_public_path__ + "static/media/inscritos2.66f2ef13.svg";